import React from 'react';
import FooterWrapper from './Footer.style';

const Footer = () => {
  return(
    <FooterWrapper>
      <div className="footer-container">
        <p className="footer-text">Mordor Intelligence © 2018 Created @ MordorLabs</p>
      </div>
    </FooterWrapper>
  );
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Main/Footer/Footer.js